import React, { Component } from "react";
import ActivityLog from "../audit-logs/audit-logs";

class PricingAuditLogs extends Component {
  state = {
    data: []
  }
  render() {
      return (
        <ActivityLog for="pricing"/>
      )
  }
}
export default PricingAuditLogs;